import { gql } from '@apollo/client'

export const GET_SYNC_CLIENT_INFORMATION = gql`
  query GetSyncClientInformation {
    tenantDaiSalesSyncClientInfo
  }
`
